exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "body,html{height:100%}:focus{outline:0}body{font-size:62.5%;font-family:'Segoe UI',Tahoma,sans-serif;margin:0;padding:0;position:relative}.highlight{border:8px solid #00BFEF;color:#00BFEF}.config-container{padding:20px}#sqlEditor{height:150px}.main-editor .sql_editor{width:70%;display:inline-block;vertical-align:top}.main-editor .settings{width:30%;vertical-align:top;display:inline-block}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/less-loader!./src/index.less
// module id = 3
// module chunks = 0